import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchProjectLog } from '../services/fetchProjectLog'

export { useProjectLog, queryKey }

const queryKey = 'hoofdleiding-project-log'

const useProjectLog = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isPending: isLoading } = useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchProjectLog({ id }),
    enabled: hasPermissions && !!id,
    refetchOnMount: true,
  })

  return {
    data: data || [],
    isLoading,
  }
}
